import { isWithinLastDays } from "./dates";
import type { Job } from "./types";

const RECENT_DAYS = 7;

/** Job was first discovered by a scan within the last week. */
export function isNewJob(job: Job): boolean {
  return isWithinLastDays(job.created_at, RECENT_DAYS);
}

/** Job's listing was found closed within the last week. */
export function isRecentlyClosedJob(job: Job): boolean {
  return isWithinLastDays(job.closed_at, RECENT_DAYS);
}
